<template>
  <div style="width: 100%  ; float: right">
    <b style="width: 100%  ; padding-right: 15px" v-if="widget.data.title!==''">{{ widget.data.title }}</b>
    <v-container fluid
                 v-if="widget.type==='table' && widget.data.name!==editOrShowTarget.split('/')[0] && widget.data.hasMultipleSelector===true">
      <v-row>
        <v-col cols="12" lg="12" xl="12" md="12" sm="12" class="mb-0 pb-0">
          <v-btn
            color="primary"
            elevation="2"
            tile
            dark
            style="height: 46px !important;"
            class="pa-5 fullwidthOnSmall ma-1"
            @click="tableMultipleSelectAll(widget.data.name).then(r=>{tableActionsSet(widget.data.model,widget.data.multipleSelectorActions,widget.data.rows,widget.data.name)})"
          >انتخاب همه

            <v-icon>
              {{ icons["mdiCheck2"] }}
            </v-icon>
          </v-btn>
          <template v-for="action in widget.data.multipleSelectorActions">
            <tile-default-table-design :widget="action" v-if="action.template==='defaultTableDesign'"
                                       style="width: max-content ; min-width: 180px"
                                       class="ml-2 float-left fullwidthOnSmall ma-1"/>
            <tile-icon-left-default-table-design :widget="action" v-if="action.template==='defaultIconLeftTableDesign'"
                                                 style="width: max-content ; min-width: 180px"
                                                 class="float-left fullwidthOnSmall ma-1"/>
          </template>
          <template v-for="button in widget.data.multipleSelectorButtons">
            <v-btn
              v-if="typeof button.modal==='undefined'"
              :color="button.color"
              class="fullwidthOnSmall ma-1"
              style="float: right"
              dark
              :style="button.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79);width: max-content ; min-width: 180px' : button.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335);width: max-content ; min-width: 180px' : button.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443);width: max-content ; min-width: 180px' : button.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000);width: max-content ; min-width: 180px' : 'background:' + button.color + ';width: max-content ; min-width: 180px' "
              elevation="2"
              left
              x-large
              tile
              height="100"
              @click="buttonDoing(button.action,button.type,widget.data.model)"

            >
              {{ button.title }}
              <v-icon
                v-if="button.icon!=='undefined'"
                large
              >
                {{ icons[button.icon] }}
              </v-icon>
            </v-btn>
            <v-dialog
              v-else
              v-model="button.modal.model"
              persistent
              max-width="600px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  style="color: white"
                  :color="button.color"
                  :style="button.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79);width: max-content ; min-width: 180px' : button.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335);width: max-content ; min-width: 180px' : button.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443);width: max-content ; min-width: 180px' : button.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000);width: max-content ; min-width: 180px' : 'background:' + button.color + ';width: max-content ; min-width: 180px' "
                  elevation="2"
                  class="fullwidthOnSmall"
                  x-large
                  tile
                  height="100"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ button.title }}
                  <v-icon
                    v-if="button.icon!=='undefined'"
                    large
                  >
                    {{ icons[button.icon] }}
                  </v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ button.modal.title }}</span>
                </v-card-title>
                <v-card-text>
                  <h2 class="text-center">{{ button.modal.message }}</h2>
                  <v-container v-if="button.modal.data==='showActions'">
                    <v-row v-for="action in widget.data.multipleSelectorActions"
                           :key="action.title+'multipleSelectorActionsForModal'">
                      <v-col>
                        {{ action.title }}
                      </v-col>
                      <v-col>
                        {{ isNaN(action.model) ? action.model : Intl.NumberFormat().format(parseInt(action.model)) }}
                        {{ action.prefix }}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="error"
                    @click="button.modal.model = false"
                  >
                    {{ button.modal.noBtn }}
                  </v-btn>
                  <v-btn
                    color="success"
                    @click="buttonDoing(button.action,button.type,widget.data.model)"
                  >
                    {{ button.modal.yesBtn }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </template>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row class="mb-0 pb-0 mt-0 pt-0">
        <v-col class="mb-0 pb-0 mt-0 pt-0" style="position:relative;">
          <v-btn
            elevation="2"
            icon
            small
            outlined
            absolute
            left
            top
            class="mt-n5 ml-n5"
            color="#028648"
            @click="excelExport"
            v-if="widget.data.enableExcel===true">
            <v-icon>{{ mdiMicrosoftExcel }}</v-icon>
          </v-btn>
          <v-data-table
            v-if="widget.type==='table' && widget.data.name!==editOrShowTarget.split('/')[0]"
            :headers="widget.data.columns"
            no-results-text="محتوایی وجود ندارد."
            no-data-text="محتوایی وجود ندارد."
            :items="widget.data.rows"
            :items-per-page="widget.data.itemPerPage"
            class="elevation-1 mt-2"
            :hide-default-footer="widget.data.rows.length<widget.data.itemPerPage-1 ? 'hide-default-footer' : null"
          >
            <template
              v-for="template in widget.data.templates"
              v-slot:[`item.${template.value}`]="{ item,header }"
            >
              <div
                v-if="template.type==='multipleSelector'"
                class="body-1"
              >
                <v-checkbox
                  :key="item.id+item.text"
                  v-model="widget.data.model"
                  :value="item.id"
                  @change="tableActionsSet(widget.data.model,widget.data.multipleSelectorActions,widget.data.rows,widget.data.name)"
                ></v-checkbox>

              </div>
              <div
                v-if="template.type==='text'"
                :class="'body-1 ' + header.className"
              >
                <template
                  v-if="typeof (header.relationHasOneName) !== 'undefined' && (header.relationHasOneName !== '' || header.relationHasOneName !== null )">
                  {{ item[header.relationHasOneName][template.value] }}
                </template>
                <template v-else>
                  <span v-if="header.numericColorColumn && item[template.value]!==''">
                    <span v-if="parseInt(header.originNumber)<parseInt(convertToNumber(item[template.value]))" style="color: #1c7430">
                      {{typeof item[template.value + 'TextAppendBefore'] !== 'undefined' ? item[template.value + 'TextAppendBefore'] : '' }}
                      {{item[template.value]}}
                      {{typeof item[template.value + 'TextAppendAfter'] !== 'undefined' ? item[template.value + 'TextAppendAfter'] : '' }}
                    </span>
                    <span v-if="parseInt(header.originNumber)>parseInt(convertToNumber(item[template.value]))" style="color: #76201c">
                      {{typeof item[template.value + 'TextAppendBefore'] !== 'undefined' ? item[template.value + 'TextAppendBefore'] : '' }}
                      {{item[template.value]}}
                      {{typeof item[template.value + 'TextAppendAfter'] !== 'undefined' ? item[template.value + 'TextAppendAfter'] : '' }}
                    </span>
                    <span v-if="parseInt(header.originNumber)===parseInt(convertToNumber(item[template.value]))">
                      {{typeof item[template.value + 'TextAppendBefore'] !== 'undefined' ? item[template.value + 'TextAppendBefore'] : '' }}
                      {{item[template.value]}}
                      {{ typeof item[template.value + 'TextAppendAfter'] !== 'undefined' ? item[template.value + 'TextAppendAfter'] : '' }}
                    </span>
                  </span>
                  <span v-else>
                    {{typeof item[template.value + 'TextAppendBefore'] !== 'undefined' ? item[template.value + 'TextAppendBefore'] : '' }}
                    {{ item[template.value] }}
                    {{typeof item[template.value + 'TextAppendAfter'] !== 'undefined' ? item[template.value + 'TextAppendAfter'] : '' }}
                  </span>
                </template>
              </div>
              <div
                v-if="template.type==='link'"
                :class="'body-1 ' + header.className"
              >
                <v-btn
                  class="ma-2"
                  outlined
                  color="indigo"
                  :to="'/'+template['value'].toString()+'/'+item['id'].toString()"
                >
                  {{ header["linkText"] }}
                </v-btn>
              </div>
              <div
                v-if="template.type==='callback'"
                :class="'body-1 ' + header.className"
              >
                <template v-for="condition in header.conditionalLinks">
                  <v-btn
                    v-if="condition.fieldValue===item[condition.fieldName] && condition.operator==='='"
                    class="ma-2"
                    outlined
                    :color="condition.color"
                    @click="()=> {
                      if (typeof header.confirmation==='boolean')
                        callBackColumn(item,widget.data.name,template,header,condition.link)
                      else
                        callConfirmationForCallback(item,widget.data.name,template,header,condition.link)
                    }"
                  >
                    {{ header["title"] }}
                  </v-btn>
                  <v-btn
                    v-if="condition.fieldValue!==item[condition.fieldName] && condition.operator==='!='"
                    class="ma-2"
                    outlined
                    :color="condition.color"
                    @click="callBackColumn(item,widget.data.name,template,header,condition.link)"
                  >
                    {{ header["title"] }}
                  </v-btn>
                </template>
                <v-btn
                  v-if="header.conditionalLinks.length===0"
                  class="ma-2"
                  outlined
                  :icon="header.viewType==='icon'"
                  :color="header.backgroundColor"
                  @click="callBackColumn(item,widget.data.name,template,header)"
                >
                  <v-icon v-if="header.viewType==='icon' || header.viewType==='textIcon'">{{ iconGenerator(header.icon) }}</v-icon>
                  <template v-if="header.viewType==='text' || header.viewType==='textIcon'">{{ header["linkText"]==='' ? header["title"] : header["linkText"] }}</template>
                </v-btn>
              </div>
              <v-chip
                v-if="template.type==='chips'"
                color="warning"
                dark
              >
                <template
                  v-if="typeof (header.relationHasOneName) !== 'undefined' && (header.relationHasOneName !== '' || header.relationHasOneName !== null )">
                  {{ item[header.relationHasOneName][template.value] }}
                </template>
                <template v-else>
                  {{ item[template.value] }}
                </template>
              </v-chip>
              <v-chip
                v-if="template.type==='gender'"
                :color="item[template.value]===1?'error':'success'"
                outlined
                dark
              >
                {{ item[template.value] === 1 ? "mard" : "zan" }}
              </v-chip>
              <v-icon
                v-if="template.type==='tick'"
                :color="item[template.value]===1?'success':'error'"
                large
              >
                {{ item[template.value] === 1 ? mdiCheck : mdiMinus }}
              </v-icon>
              <v-chip
                v-if="template.type==='chips_success'"
                color="success"
                dark
              >
                {{ item[template.value] }}
              </v-chip>
              <v-chip
                v-if="template.type==='date'"
                label
                outlined
              >
                <span v-if="item[template.value]==='' || item[template.value]===null">--/--/----</span>
                {{ item[template.value] }}
              </v-chip>
              <v-chip
                v-if="template.type==='dateTime'"
                label
                outlined
                style="direction: ltr"
              >
                <span v-if="item[template.value]==='' || item[template.value]===null">--/--/----</span>
                {{ item[template.value] }}
              </v-chip>
              <v-img
                v-if="template.type==='image'"
                :src="item[template.value]"
                class="rounded-circle ma-5"
                width="50"
                height="50"
              >
              </v-img>

              <v-btn
                v-if="template.type==='detail'"
                class="mx-2"
                fab
                dark
                small
                color="primary"
                outlined
                :to="'/'+widget.data.name+'/single/'+item.id"
              >
                <v-icon>
                  {{ mdiDetails }}
                </v-icon>
              </v-btn>
              <v-btn
                v-if="template.type==='print'"
                class="mx-2"
                fab
                dark
                small
                color="black"
                outlined
                @click="printRecord(header,item)"
              >
                <v-icon>
                  {{ mdiPrinter }}
                </v-icon>
              </v-btn>
              <v-btn
                v-if="template.type==='editSingle'"
                class="mx-2"
                fab
                dark
                small
                color="primary"
                outlined
                :to="'/'+widget.data.name+'/edit/'+item.id"
              >
                <v-icon>
                  {{ editIcon }}
                </v-icon>
              </v-btn>
              <v-btn
                v-if="template.type==='edit'"
                class="mx-2"
                fab
                dark
                small
                color="success"
                outlined
                @click="UpdateFormView(item,widget.data.name)"
              >
                <v-icon>
                  {{ editIcon }}
                </v-icon>
              </v-btn>
              <v-btn
                v-if="template.type==='delete'"
                class="mx-2"
                fab
                dark
                small
                color="error"
                outlined
                @click="showDeleteConfirmationDialog(item,widget.data.name,widget.data.columns)"
              >
                <v-icon>
                  {{ deleteIcon }}
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="overflow: hidden">
          <v-pagination
            v-if="widget.type==='table' && widget.data.serverPagination===1 && widget.data.name!==editOrShowTarget.split('/')[0]"
            v-model="widget.data.pagination.current_page"
            :length="widget.data.pagination.last_page"
            :prev-icon="mdiMenuLeft"
            :next-icon="mdiMenuRight"
            circle
            @input="onPagination(widget.data.name,widget.data.pagination.current_page)"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>
    <div id="node-id"></div>
    <div style="position: fixed ; top:-99999990px">
      <div id="printThis">
        <link href="https://fonts.cdnfonts.com/css/iranian-sans" rel="stylesheet">
        <div
          style="width: 257px ; float: right; border: 1px solid lightgray ; border-radius: 2px ; margin: 10px ; margin-top: 20px ; margin-right: -50px">
          <template v-for="item in printRecordResult">
            <div v-if="item.type==='image'"
                 :style="'padding: 5px ; float: right ; width: 100% ; margin-right: -10px ; text-align: ' + item.valueAlign">
              <img :src="baseUrlRaw+item.value" :alt="item.value" style="width: 60px">
            </div>
            <div v-if="item.type==='text'" style="padding: 3px ; float: right ; width: 100% ; margin-right: -10px">
              <div :style="'width: 50% ; float: right; direction: rtl; text-align :'+ item.lableAlign">
              <span style="padding: 2px 10px;float: right ; width: 100% ; font-size: 12px">
                {{ item.label }}
              </span>
              </div>
              <div :style="'width: 50% ; float: right   ; direction: rtl; text-align:' + item.valueAlign">
              <span
                style="padding-left: 10px ; padding-top: 2px ; padding-bottom: 2px ;  float: left ; width: 100% ; font-size: 12px">
                {{ item.value }}
              </span>
              </div>
            </div>
            <div v-if="item.type==='barcode'" class="replaceContent"
                 style="padding: 3px ; width: 100% ; margin-right: -10px ; text-align: center ; float: left">
              <barcode class="barcode" width="1" ref="barcode" :display-value="false" :value="item.value" height="25px">
                Show this if the rendering fails.
              </barcode>
            </div>
          </template>
        </div>
      </div>
    </div>
    <confirmation
      :message="confirmation.message"
      :data="confirmation.data"
      :no-title="confirmation.noTitle"
      :no-color="confirmation.noColor"
      :yes-title="confirmation.yesTitle"
      :yes-color="confirmation.yesColor"
      :confirmation-dialog-status="confirmation.status"
      @yes="yes"
      @no="no"
    />
  </div>
</template>

<script>
import moment from "jalali-moment";
import axios from "@axios";
import baseConfig from '@/../baseConfig'
import router from "@/router";
import VueBarcode from 'vue-barcode'
import {
  mdiCheck,
  mdiCheckCircleOutline,
  mdiCreditCard,
  mdiCreditCardCheck, mdiEyeOutline, mdiMenuLeftOutline, mdiMenuRightOutline,
  mdiMinusCircleOutline, mdiPen,
  mdiPlus, mdiTrashCan, mdiPrinter, mdiMicrosoftExcel
} from "@mdi/js";

import goTo from 'vuetify/lib/services/goto'
import TileDefaultTableDesign from "@/views/generator/vueContents/tile/tile-default-table-design";
import TileIconLeftDefaultTableDesign from "@/views/generator/vueContents/tile/tile-icon-left-default-table-design";
import store from "@/store";
import {removeCharFromString} from "@/views/generator/page-handler";
import Confirmation from "@/views/generator/dialogs/confirmation";
import confirmation from "@/views/generator/dialogs/confirmation";
import  * as mdi from "@mdi/js";

export default {
  name: "full-dynamic-table",
  components: {Confirmation, TileIconLeftDefaultTableDesign, TileDefaultTableDesign, 'barcode': VueBarcode},
  props: {
    widget: Object,
    widgets: Array,
    filterModelForTableExcel: Array,
    editOrShowTarget: String,
    filter: Object
  },
  data() {
    return {
      mdi : mdi,
      confirmation : {
        message:'',
        data:{},
        status:false,
        yesTitle:'',
        yesColor:'',
        noTitle:'',
        noColor:'',
      },
      printLabel: '',
      printRecordResult: [],
      baseUrlRaw: baseConfig.basUrlRaw,
      baseUrl: baseConfig.baseUrl,
      icons: {
        mdiCheck2: mdiCheck,
        mdiCreditCard: mdiCreditCard,
        mdiPlus: mdiPlus,
        mdiCreditCardCheck: mdiCreditCardCheck,
      },
      mdiPrinter: mdiPrinter,
      mdiMicrosoftExcel: mdiMicrosoftExcel,
      editIcon: mdiPen,
      mdiCheck: mdiCheckCircleOutline,
      mdiMinus: mdiMinusCircleOutline,
      deleteIcon: mdiTrashCan,
      mdiDetails: mdiEyeOutline,
      mdiMenuLeft: mdiMenuLeftOutline,
      mdiMenuRight: mdiMenuRightOutline,
    }
  },
  methods: {
    iconGenerator(icon){
     return  eval(`this.mdi.${icon}`)
    },
    convertToNumber(data){
      return removeCharFromString(data,',')
    },
    async excelExport() {
      let action = ''
      const body = new FormData()
      this.widget.data.columns.map(c => {
        body.append("columns[]", c.name + "-" + c.type + "-" + c.title)
      })
      body.append("excel", "yes")
      body.append("table", this.widget.data.name)
      body.append("widget", this.widget.data.name + "Filter")
      this.widgets.map(async aw => {
        if (aw.type === 'form') {
          if (aw.data.name === this.widget.data.name + "Filter") {
            this.filterModelForTableExcel.map(ex => {
              if (ex.model !== '') {
                if (ex.type !== 'date')
                  body.append(ex.name, removeCharFromString(ex.model, ex.strMask))
                else
                  body.append(ex.name, moment.from(ex.model, 'fa', 'YYYY/MM/DD').locale('en').format('YYYY-MM-DD'))
              }
            })
            aw.data.elements.map(e => {
              action = aw.data.action
            })
          }
        }
        if (action === '') {
          action = this.widget.data.queryFilterUrl
        }
      })
      await axios.post(baseConfig.baseUrl + action, body, {
        responseType: 'blob'
      }).then(async r => {
        console.log(r.data)
        let fileURL = window.URL.createObjectURL(new Blob([r.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', this.widget.data.name + '.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
    },
    async printRecord(header, item) {
      this.printRecordResult = []
      this.printLabel = header.label
      await header.columns.map((h) => {
        this.printRecordResult.push({
          "type": h.type,
          "value": item[h.field],
          "valueAlign": h.fieldAlign,
          "label": h.label,
          "labelAlign": h.labelAlign
        })
      })


      setTimeout(function () {

        const contents = document.getElementById('printThis').innerHTML
        const frame1 = document.createElement('iframe')
        frame1.name = 'frame1'
        frame1.style.position = 'absolute'
        frame1.style.top = '-1000000px'
        document.body.appendChild(frame1)
        const frameDoc = (frame1.contentWindow) ? frame1.contentWindow : (frame1.contentDocument.document) ? frame1.contentDocument.document : frame1.contentDocument
        frameDoc.document.open()
        frameDoc.document.write('<html><head><title>' + header.label + '</title>')
        frameDoc.document.write('<style>*{font-family: \'Iranian Sans\', sans-serif !important;}</style></head><body style="margin-right: 80px">')
        frameDoc.document.write(contents)

        frameDoc.document.write('</body></html>')
        frameDoc.document.close()
        setTimeout(function () {
          window.frames["frame1"].focus()
          window.frames["frame1"].print()
          document.body.removeChild(frame1)
        }, 500)
      }, 100)


    },
    async buttonDoing(action, type, data) {
      if (type === "post") {
        const body = new FormData()
        data.map(d => body.append("ids[]", d))
        body.append("objectName", this.widget.data.name)
        let resultAction = action.includes("http");
        let whereIsAction = ""
        if (resultAction) {
          whereIsAction = action
        } else {
          whereIsAction = baseConfig.baseUrl + action
        }

        let dynaAxios
        if (type.toLowerCase() === "post")
          dynaAxios = axios.post
        if (type.toLowerCase() === "delete")
          dynaAxios = axios.delete

        await dynaAxios(whereIsAction, body).then(async r => {
          let response = {
            data: {
              message: r.data.message,
              status: r.data.status
            }
          }

          this.$emit('response_handler', response, true)
          if (typeof r.data.redirect !== 'undefined' || r.data.redirect !== "") {
            if (r.data.redirect !== '') {
              store.dispatch('message/setMessage', response).then(() => {

              })
              let result = r.data.redirect.includes("http");
              if (result) {
                window.location.href = r.data.redirect
              } else {
                await router.push(`/${r.data.redirect}`)
              }
            } else {
              this.$emit('filter-page', r)
            }
          }

        })
      } else if (type === "internalLink") {
        await router.push(action)
      } else if (type === "externalLink") {
        window.open(action)
      }

    },
    async tableMultipleSelectAll(table) {
      let ids = [];
      this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.rows.map(r => ids.push(r.id)) : null)
      this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.isAll === "undefined" ? w.data.isAll = 1 : w.data.isAll === 1 ? w.data.isAll = 0 : w.data.isAll = 1 : null)
      this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.isAll === 1 ? w.data.model = ids : w.data.model = [] : null)
    },
    async tableActionsSet(model, actions, rows, table) {
      actions.forEach(action => {
        if (action.type === "avg") {
          let count = 0
          let sum = 0
          this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.multipleSelectorActions.map(m => m.type === "avg" ? m.model = 0 : null) : null)
          this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.multipleSelectorActions.map(m => m.type === "avg" ? m.avg = {
            count: 0,
            sum: 0
          } : null) : null)
          this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.multipleSelectorActions.map(m => m.type === "avg" ? rows.map(r => {
            count = 0
            sum = 0
            model.map(mo => {
              if (mo === r["id"]) {
                m.avg.count += 1
                m.avg.sum += parseInt(r[m.field].replaceAll(',', ''))
                m.model = m.avg.sum / m.avg.count
              }
            })
          }) : null) : null)
        }
        if (action.type === "sum") {
          this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.multipleSelectorActions.map(m => m.type === "sum" ? m.model = 0 : null) : null)
          this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.multipleSelectorActions.map(m => m.type === "sum" ? rows.map(r => {
            model.map(mo => {
              if (mo === r["id"]) {
                m.model += parseInt(r[m.field].replaceAll(',', ''))
              }
            })
          }) : null) : null)
        }
        if (action.type === "count") {
          this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.multipleSelectorActions.map(m => m.type === "count" ? m.model = 0 : null) : null)
          this.widgets.map(w => w.type === 'table' && w.data.name === table ? w.data.multipleSelectorActions.map(m => m.type === "count" ? rows.map(r => {
            model.map(mo => {
              if (mo === r["id"]) {
                m.model += 1
              }
            })
          }) : null) : null)

        }
      });
    },

    yes(data){
      console.log(data)
      this.callBackColumn(data.item, data.wName, data.template, data.header,data.link)
      this.confirmation.status=false
    },
    no(){
      this.confirmation.status=false
    },
    callConfirmationForCallback(item, wName, template, header,link){
      let message = header.confirmation.message
      for (const [key, value] of Object.entries(item)) {
        message = message.replaceAll('@'+key+'@', '<b style="border-bottom: 1px dotted gray">' + value + '</b>')
      }
      this.confirmation.status=true
      this.confirmation.message=message
      this.confirmation.yesTitle=header.confirmation.yesTitle
      this.confirmation.yesColor=header.confirmation.yesColor
      this.confirmation.noTitle=header.confirmation.noTitle
      this.confirmation.noColor=header.confirmation.noColor
      this.confirmation.data= {item, wName, template, header,link}
    },
    async callBackColumn(item, wName, template, header,link) {
      const body = new FormData()
      body.append('id', item.id)
      body.append('appId', baseConfig.appId)
      if (header.getBaseUrl === 1) {
        let getUrl = window.location
        let baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
        body.append('baseUrl', baseUrl)
      }

      Object.entries(header.params).forEach(p => body.append(p[0], p[1]))

      header.paramsFromRecord.map(pfr => body.append(pfr, item[pfr]))

      /*console.log(header.params)
      header.params.map(p=>console.log(p))*/
      let Rlink = template.value
      console.log(typeof link)
      console.log( link)
      if (link !=='')
        if (typeof link !=='undefined')
          Rlink=link

      await axios.post(`${baseConfig.baseUrl + wName}/${Rlink}/callback`, body).then(r => {
        let response = {
          data: {
            message: r.data.message,
            status: r.data.status
          }
        }

        if (typeof r.data.submit !== 'undefined') {
          let inputs = ""
          r.data.submit.fields.map(f => inputs += "<input type=\"hidden\" id='" + f.name + "' name='" + f.name + "' value='" + f.value + "'>")
          let node = document.getElementById('node-id');
          node.innerHTML = "<form method='post' id=\"submition\" action='" + r.data.submit.action + "'>\n" +
            inputs +
            "</form>"
          setTimeout(document.forms['submition'].submit(), 1000)
        } else if (r.data.redirect !== '') {
          if (r.data.redirect !== '') {
            store.dispatch('message/setMessage', response).then(() => {

            })
            let result = r.data.redirect.includes("http");
            if (result) {
              window.location.href = r.data.redirect
            } else {
              router.push(`/${r.data.redirect}`)
            }
          }
        } else if (typeof r.data.dialog !== 'undefined') {
          this.$emit('open-dialog', r.data.dialog, null, r.data.targetForm, r)
        } else
          this.$emit('response_handler', response, true)
      })
    },
    UpdateFormView(record, tableName) {

      this.widgets.map(w => w.type === 'form' && w.data.id === tableName ? w.data.elements.map(async e => {
        w.data.hideOnUpdateFields.forEach(h => {
          if (e.name === h) {
            e.readOnly = true
          }
        })

        if (e.type === 'dropdown' && typeof e.onChange.change !== 'undefined') {
          let value = record[e.name]

          await axios.post(baseConfig.baseUrl + e.onChange.dataFrom, {value}).then(r => {
            if (typeof e.onChange.change === 'string') {
              // eslint-disable-next-line no-return-assign

              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(ee => {
                if (ee.name === e.onChange.change) {
                  ee.options = r.data.data
                  //ee.model=parseInt(ee.model)
                }
              }) : null))
            } else {
              for (const [key, value] of Object.entries(e.onChange.change)) {

                let v = e.onChange.change.filter(c => c.field === value.field.toString())[0].destination;

                this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
                  if (e.name === value.field) {
                    e.options = r.data.data[v]
                    //e.model=parseInt(e.model)
                  }
                }) : null))

              }

            }
          })

        }
      }) : null)

      goTo(`#${tableName}`)
      // eslint-disable-next-line no-return-assign,no-nested-ternary
      //   e.fromRelation==='' ? e.model = record[e.name].toString() : console.log(e)          // record[e.name] !== null ? e.model = record[e.name].toString() : null
      this.widgets.map(w => (w.type === 'form' && w.data.id === tableName ? w.data.elements.map(e => (e.type === 'text' || e.type === 'textarea' || e.type === 'radiobutton' || e.type === 'date' || e.type === 'time' ? e.fromRelation !== "" ? e.model = record[e.fromRelation][e.name] : record[e.name] !== null ? e.model = record[e.name].toString() : "" : e.type === 'checkbox' ? record[e.name] !== null ? e.model = record[e.name].replace('[', '').replace(']', '').split(',') : null : e.type === 'image' ? record[e.name] !== null ? this.imageFormUrl = record[e.name] : null : null)) : null))
      this.widgets.map(w => (w.type === 'form' && w.data.id === tableName ? w.data.elements.map(e => (e.type === 'dropdown' && e.searchable === false ? e.fromRelation !== "" ? e.model = record[e.fromRelation][e.name] : record[e.name] !== null ? e.model = record[e.name].toString() : "" : null)) : null))
      this.widgets.map(w => (w.type === 'form' && w.data.id === tableName ? w.data.elements.map(e => (e.type === 'dropdown' && e.searchable === true ? e.fromRelation !== "" ? e.model = {
        value: record[e.fromRelation][e.name],
        text: record[e.fromRelation][e.name + "Text"]
      } : record[e.name] !== null ? e.model = {
        value: record[e.name].toString(),
        text: record[e.name + "Text"].toString()
      } : "" : null)) : null))
      // eslint-disable-next-line no-return-assign,no-param-reassign
      this.widgets.map(w => (w.type === 'form' && w.data.id === tableName ? w.data.updateId = record.id : null))
      // eslint-disable-next-line no-return-assign,no-param-reassign
      this.widgets.map(w => (w.type === 'form' && w.data.id === tableName ? w.data.valid = false : null))


    },
    showDeleteConfirmationDialog(record, tableName, columns) {
      let deleteRecordData = {
        record: record,
        tableName: tableName,
        columns: columns
      }
      let deleteConfirmationDialog = true;
      this.$emit('show-delete-confirmation-dialog', deleteRecordData, deleteConfirmationDialog)
    },
    onPagination(name, current) {
      this.$emit('on-pagination', name, current, this.filter)
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .fullwidthOnSmall {
    width: 100% !important;
  }
}
</style>
<style>
.theme--light.v-input input, .theme--light.v-input textarea {
  direction: ltr;
  text-align: right;
}
.ltrRight{
  direction: ltr !important;
  text-align: right !important;;
}
</style>
